import React from 'react';

import Circle from 'components/circle';
import RichText from 'components/rich-text';
import Button from 'components/button';

import './style.css';

const BuyNow = () => {
  return (
    <section className="buy-now">
      <Circle
        className="about-circle-03"
        width="1000px"
        angle={180}
        distance={16}
        blur={16}
      />
      <div className="buy-now-media">
        <video controls={false} autoPlay loop muted>
          <source src="/out.webm" type="video/webm" />
        </video>
      </div>

      <div className="buy-now-message">
        <RichText className="buy-now-message-content">
          <h2 className="buy-now-title">
            Continued
            <br />
            Success
          </h2>

          <p>
            Tweak provides you expert recommendations on how to change and grow,
            without any long-term commitments. But successful business grows
            exponentially—and we’re here every step of the way.
          </p>
          <p>
            We recommend additional Tweaks once every six months, so you can
            keep the momentum.
          </p>
          <p>To help you do that, your additional Tweaks are 20% off.</p>
        </RichText>
        <Button hierarchy="tertiary" href="/signup">
          Buy
        </Button>
      </div>
    </section>
  );
};

export default BuyNow;
